"use strict";

const toTitleCase = (str) => {
    return str.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
}

const capitalizeRegexp = new RegExp("(?!("+excludeWords.join("|")+"))(\\b[A-Z]{2,3}\\b)", "gi");
const capitalizeAbbreviations = (text) => {
    //capitalize Abbreviations
    return text.replace(
        capitalizeRegexp,
        function(txt) {
            return txt.toUpperCase();
        }
    );
}
module IdMgr {

    export function YesNo() {
        return function (input): string {
            return input ? "Yes" : "No";
        }
    }

    export function BuySell() {
        return function (input): string {
            if (input == 'B') {
                return 'Buy'
            }
            else if (input == 'S') {
                return 'Sell'
            }
            else {
                return input
            }
        }
    }

    export function NotBefore() {    
        return function (items, field, notBeforeDate) {  

            var filtered = [];
            angular.forEach(items, function (item) {              
                if (moment(item[field]).isAfter(notBeforeDate)) {
                    filtered.push(item);
                }
            });
            return filtered;
        }
    }

    export function NotAfter() {
        return function (items, field, notAfterDate) {

            var filtered = [];
            angular.forEach(items, function (item) {
                if (moment(item[field]).isBefore(notAfterDate)) {
                    filtered.push(item);
                }
            });
            return filtered;
        }
    }

    export function DateFilter() {
        return function(items, key, from, to) {
            if (!items) {
                return null;
            }
            var df = moment(from);
            var dt = moment(to);
            var result = [];
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var itemDateRaw = item[key];
                var itemDate = moment(itemDateRaw);

                if (itemDate.isSameOrAfter(df) && itemDate.isSameOrBefore(dt)) {
                    result.push(item);
                }
            }
            return result;
        }
    }

    export function AccountName() {
        return function (input): string {
            return capitalizeAbbreviations(toTitleCase(input));
        }
    }

    export function TitleCase() {
        return function (items, filterOn) {
            if (filterOn === false) {
                return items;
            }
            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                angular.forEach(items, function (item) {
                    for (var i = 0; i < items.length; i++) {
                        items[i][filterOn] = items[i][filterOn].replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();})
                    }
                })
            }
            return items;
        }
    }

    export function Unique() {

        return function (items, filterOn) {

            if (filterOn === false) {
                return items;
            }

            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                var hashCheck = {}, newItems = [];

                var extractValueToCompare = function (item) {
                    if (angular.isObject(item) && angular.isString(filterOn)) {
                        return item[filterOn];
                    } else {
                        return item;
                    }
                };

                angular.forEach(items, function (item) {
                    var valueToCheck, isDuplicate = false;

                    for (var i = 0; i < newItems.length; i++) {
                        if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                            isDuplicate = true;
                            break;
                        }
                    }
                    if (!isDuplicate) {
                        newItems.push(item);
                    }

                });
                items = newItems;
            }
            return items;
        }
    };

    export function Percent() {
        return function (input, precision): string {
                precision = precision || 0;
                return (input || 0.0).toFixed(precision) + "%";
        }
    }

    export function PlusMinus() {
        return function (input): string {
            return input >= 0 ? "+" : "";
        }
    }

    export function StripHtml() {
        return function (input): string {
            return input ? String(input).replace(/<[^>]+>/gm, '') : '';
        }
    }

    export function ForAccountType() {
        return function (reportTypes, accountType: string): Array<any> {
            var filteredList = [];
            angular.forEach(reportTypes, function (reportType, key) {
                if (accountType === "Accolade" || accountType === reportType.accountType) {
                    filteredList.push(reportType);
                }
            });
            return filteredList;
        }
    }

    export function Abs() {
        return function (input: number): number {
            if (input === null || input === undefined) {
                return input;
            } else {
                return Math.abs(input);
            }
        }
    }

    export function ConvertNegative() {
        return function (input): string {
            if (input && input.indexOf("-") === 0) {
                input = String(input).replace('-', '');
                let openingParethensis = "(";
                input = openingParethensis.concat(input, ")");
            }
            return input;
        }
    }
}

var filtersModule = angular.module("app.filters", []);
filtersModule.filter("yesNo", IdMgr.YesNo);
filtersModule.filter("buySell", IdMgr.BuySell);
filtersModule.filter("notBefore", IdMgr.NotBefore);
filtersModule.filter("notAfter", IdMgr.NotAfter);
filtersModule.filter("unique", IdMgr.Unique);
filtersModule.filter("dateFilter", IdMgr.DateFilter);
filtersModule.filter("percent", IdMgr.Percent);
filtersModule.filter("plusMinus", IdMgr.PlusMinus);
filtersModule.filter("stripHtml", IdMgr.StripHtml);
filtersModule.filter("forAccountType", IdMgr.ForAccountType);
filtersModule.filter("abs", IdMgr.Abs);
filtersModule.filter("titleCase", IdMgr.TitleCase);
filtersModule.filter("accountName", IdMgr.AccountName);
filtersModule.filter("convertNegative", IdMgr.ConvertNegative);

